import { Card, Col, Container, Row } from "react-bootstrap";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import {
  createNewProduct,
  fetchEditProduct,
  fetchProductList,
} from "../actions/product";
import {
  fetchClearProductCategoryAllFormList,
  fetchProductCategoryAllFormList,
} from "../actions/productCategory";
import { useNavigate, useParams } from "react-router-dom";

import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import CollapseRadioButtonsList from "../components/Admin/Reusable/CollapseRadioButtonsList";
import FormSystemInformation from "../components/Admin/Reusable/FormSystemInformation";
import InputField from "../components/Admin/Reusable/InputField";
import SelectStatus from "../components/Admin/Reusable/Form/SelectStatus";
import SubmitButtonForm from "../components/Admin/Reusable/Form/SubmitButtonForm";
import { basicFormValidationHandler } from "../utils";
import { fetchCountryFormList } from "../actions/country";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const ProductAdd = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation();
  //breadcrumb
  const translateForm = "productsForm";
  const translateModule = "products";
  const pageType = id ? "Edit" : "Add";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const initialState = {
    name: "",
    points: "",
    serialNumber: "",
    categoryId: "",
    ean: "",
    status: "ACTIVE",
  };

  const [data, setData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [countryValue, setCountryValue] = useState("");

  const { productDetail } = useSelector((state) => state.productReducer);
  const { countryFormList } = useSelector((state) => state.countryReducer);
  const { productCategoryAllFormList } = useSelector(
    (state) => state.productCategoryReducer
  );

  const handleInputChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  //ako je korisnik setovan da je admin drzave odmah se nakon dobijanja drzava proverava da li je count 1 i odmah je setuje
  useEffect(() => {
    if (countryFormList.length == 1 && !countryValue) {
      const singleCountry = countryFormList[0];
      setCountryValue(singleCountry.id);
      dispatch(fetchProductCategoryAllFormList(singleCountry.id));
    }
  }, [countryFormList, countryValue, dispatch]);

  //pozvati podatke za drzave kako bi izlistali u selektu
  useEffect(() => {
    dispatch(fetchCountryFormList());
  }, [dispatch]);

  useEffect(() => {
    if (!id) {
      // Ako `id` ne postoji, očisti stanje za novu kreaciju
      setData(initialState);
      dispatch(fetchClearProductCategoryAllFormList());
    } else {
      // Ako `id` postoji, učitaj podatke za korisnika
      dispatch(fetchProductList(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (productDetail && id) {
      console.log(productDetail?.points, 'productDetail')

      setData({
        ...data,
        name: productDetail.name || "",
        points: productDetail?.points,
        serialNumber: productDetail.serialNumber || "",
        ean: productDetail.ean || "",
        categoryId: productDetail.categoryId || "",
        status: productDetail.status || "ACTIVE",
        createdAt: productDetail.createdAt || "",
        updatedAt: productDetail.updatedAt || "",
      });
      if (productDetail && productDetail.countryId) {
        setCountryValue(productDetail.countryId);
        dispatch(fetchProductCategoryAllFormList(productDetail.countryId));
      }
    }
  }, [productDetail, id]);

  const clientValidationHandler = () => {
    const { name, points, serialNumber, categoryId } = data;

    let errorsObject = {};

    errorsObject = basicFormValidationHandler({
      name,
      serialNumber,
      categoryId,
      countryValue,
    });

    const pointsValue = typeof points === "string" ? points.trim() : points;

    if (pointsValue === undefined || pointsValue === null || pointsValue === "") {
      errorsObject.points = t("taskAdd.requiredField");
    }

    setErrors(errorsObject);

    if (!isEmpty(errorsObject)) {
      let message = "Morate popuniti sva obavezna polja";

      if (errorsObject.categoryId) message += ", morate odabrati kategoriju";

      toast.error(message, { theme: "colored" });
    }

    return !isEmpty(errorsObject);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (clientValidationHandler()) {
      return;
    }
    data.countryId = countryValue;
    if (id) {
      data.id = id;
      dispatch(fetchEditProduct(data, navigate));
    } else {
      dispatch(createNewProduct(data, navigate));
    }
  };

  const handleChangeCountry = (event) => {
    setCountryValue(event.target.value);
    dispatch(fetchProductCategoryAllFormList(event.target.value));
  };

  return (
    <Fragment>
      <Breadcrumb
        breadcrumbItems={breadcrumbItems}
        type={translateModule}
        id={id}
        pageType={pageType}
        extraTitle={productDetail && productDetail.name}
      />
      <Container>
        <Row>
          <Col lg={12}>
            <form onSubmit={handleSubmit} noValidate>
              <Row>
                <Col lg={12}>
                  <div className="text-end mb-2">
                    <SubmitButtonForm id={id} />
                  </div>
                </Col>
              </Row>

              <Row>
                <Col lg={9}>
                  <Row>
                    <Col lg={12}>
                      <Card>
                        <Card.Header>
                          <h6 className="mb-0">
                            {t(`${translateForm}.basicInfo`)}
                          </h6>
                        </Card.Header>
                        <Card.Body>
                          <div className="product-holder-admin-left-side-text">
                            <Row>
                              <Col lg={8} md={12} xs={12} className="mb-4">
                                <InputField
                                  label={t(`${translateForm}.name`)}
                                  name="name"
                                  value={data.name}
                                  onChange={handleInputChange}
                                  error={errors}
                                  errorsHandler={setErrors}
                                  fullWidth
                                  size="small"
                                  required
                                />
                              </Col>
                              <Col lg={3} md={12} xs={12} className="mb-4">
                                <InputField
                                  label={t(`${translateForm}.ean`)}
                                  name="ean"
                                  value={data.ean}
                                  onChange={handleInputChange}
                                  error={errors}
                                  errorsHandler={setErrors}
                                  fullWidth
                                  size="small"
                                />
                              </Col>
                              <Col lg={4} md={12} xs={12} className="mb-4">
                                <FormControl
                                  fullWidth
                                  size="small"
                                  required
                                  error={errors?.countryValue}
                                  disabled={countryFormList?.length == 1}
                                >
                                  <InputLabel id="demo-simple-select-label">
                                    {t(`${translateForm}.country`)}
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={countryValue}
                                    label={t(`${translateForm}.country`)}
                                    onChange={handleChangeCountry}
                                    size="small"
                                  >
                                    {countryFormList?.map((item, key) => (
                                      <MenuItem value={item.id} key={key}>
                                        {item.name}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                  {errors?.countryValue && (
                                    <FormHelperText>
                                      obavezno polje
                                    </FormHelperText>
                                  )}
                                </FormControl>
                              </Col>
                              <Col lg={3} md={12} xs={12} className="mb-4">
                                <InputField
                                  label={t(`${translateForm}.points`)}
                                  name="points"
                                  value={data.points}
                                  onChange={handleInputChange}
                                  error={errors}
                                  errorsHandler={setErrors}
                                  fullWidth
                                  required
                                  size="small"
                                />
                              </Col>
                              <Col lg={5} md={12} xs={12} className="mb-4">
                                <InputField
                                  label={t(`${translateForm}.serialNumber`)}
                                  name="serialNumber"
                                  value={data.serialNumber}
                                  onChange={handleInputChange}
                                  error={errors}
                                  errorsHandler={setErrors}
                                  fullWidth
                                  // disabled={id ? true : false}
                                  required
                                  size="small"
                                />
                              </Col>
                            </Row>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>

                    <Col lg={12}>
                      <Card>
                        <Card.Header>
                          {t(`${translateForm}.categoryTitle`)}
                        </Card.Header>
                        <Card.Body>
                          <CollapseRadioButtonsList
                            items={productCategoryAllFormList}
                            name="categoryId"
                            value={data.categoryId}
                            onChange={handleInputChange}
                            id={id}
                          />
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Col>
                <Col lg={3}>
                  <Row>
                    <Col lg={12}>
                      <SelectStatus
                        data={data}
                        handleInputChange={handleInputChange}
                      />
                    </Col>
                    {id && (
                      <Col lg={12}>
                        <FormSystemInformation data={data} />
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
            </form>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default ProductAdd;
